// Note: used to differentiate the scope of component when the same
// component is shared between admin and settings.
export enum componentScope {
  application = 'application',
  workspace = 'workspace',
}
